<template>
  <!--Stopwatch-->
  <div class="inner-card-content">
    <p class="text">Time Elapsed</p>
    <div class="time">
      <span class="time-unit hh">{{stopWatchCounter[0]}}</span>
      <span class="time-separator">:</span>
      <span class="time-unit mm">{{stopWatchCounter[1]}}</span>
      <span class="time-separator">:</span>
      <span class="time-unit ss">{{stopWatchCounter[2]}}</span>
    </div>
  </div>
</template>
  
<script>
import {mapGetters} from 'vuex'
export default {
  name: "stop-watch",
  data() {
    return {
      elapsedTime: 0, //In seconds
      timer: undefined
    };
  },
  props : {
    stop : {
      type : Boolean,
      default : false
    }
  },
  computed: {
    ...mapGetters(['fetchColors']),
    formattedElapsedTime() {
      const date = new Date(null);
      date.setSeconds(this.elapsedTime);
      const utc = date.toUTCString();
      return utc.substr(utc.indexOf(":") - 2, 8);
    },
    stopWatchCounter(){
      return this.formattedElapsedTime.split(':')
    }
  },
  watch : {
    stop : function(new_val){
      if(new_val){
        //If stop is set to true, then stop it
        this.stopTimer()
      }
    }
  },
  methods: {
    start() {
      this.timer = setInterval(() => {
        this.elapsedTime += 1;
        this.$emit('time', this.elapsedTime)
      }, 1000);
    },
    stopTimer() {
      clearInterval(this.timer);
    },
    reset() {
      this.elapsedTime = 0;
    }
  },
  created(){
    this.start()
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;600;700&display=swap");

.inner-card-content {
  width: 100%;
}

.text {
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #666666;
  font-size: 0.85rem;
  margin-bottom: 4px;
}

.time {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 2px;
  font-weight: 700;
  font-size: 1.8rem;
  letter-spacing: 0.03em;
  color: #333;
  font-family: 'Source Sans Pro', monospace;
}

.time-unit {
  background: #8919e7;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  min-width: 32px;
  text-align: center;
  font-weight: 700;
  position: relative;
}

.time-separator {
  color: #aaa;
  font-weight: 400;
  margin: 0 2px;
}

@media screen and (max-width: 767px) {
  .time {
    font-size: 1.4rem;
  }
  
  .time-unit {
    min-width: 26px;
  }
  
  .text {
    font-size: 0.75rem;
  }
}

@media screen and (max-width: 480px) {
  .time {
    font-size: 1.2rem;
    gap: 1px;
  }
  
  .time-unit {
    min-width: 22px;
  }
  
  .time-separator {
    margin: 0 1px;
  }
  
  .text {
    font-size: 0.7rem;
  }
}

@media screen and (max-width: 360px) {
  .time {
    font-size: 1.1rem;
  }
  
  .time-unit {
    min-width: 20px;
  }
  
  .text {
    font-size: 0.65rem;
  }
}
</style>